import React from "react"
import { useParams } from "react-router-dom";
import logger from "../../Utils/logger";


const Bottom=(props)=>{
    logger.log("tahzeeb---Bottom------>",props)
    const {slot_id} =useParams()
    const {machine_id} =useParams()

//logger.log("khan props bottom",props.props.productDetailsData&&props.props.productDetailsData.activeCount)

const mvIdToFind =props?.productDetailsData?.slotId; // Replace with the ID you want to search for
const foundItem =props?.cartItemsList?.find(item => item?.slotId === mvIdToFind);

logger.log("khan tahzeeb foundItem",foundItem)
//logger.log("khan foundItem----",mvIdToFind)
const RemoveToCartFromBottom=(e,slotid,count)=>{
const machineId=localStorage.getItem("machineId")
   props?.RemovefromCart(e,slotid,count,machineId)

}

const addToCartFromBottom=(e,index,slotid,count)=>{
    //logger.log("khan slotid,count,machine_id",slotid,count,machine_id)
    const machineId=localStorage.getItem("machineId")

        props?.AddIntoCart({e,i:index,sId:slotid,myCartcount:count,machine_id:machine_id,replace:false})
    
    }

  function calculateFinalPrice(item) {
  const mvOfferPrice = item?.mvOfferPrice || 0;
  const offerDetails = item?.offer_details;


  
  // ❌ No offer OR not a Discount coupon
  if (!offerDetails || offerDetails.couponType !== "Discount") {
    return mvOfferPrice;
  }

  const { flatTypeId, flatAmount } = offerDetails;

  let discount = 0;

  if (flatTypeId === 1) {
    // Flat amount (₹)
    discount = flatAmount || 0;
  } else if (flatTypeId === 2) {
    // Percentage (%)
    discount = (mvOfferPrice * (flatAmount || 0)) / 100;
  }

  const finalPrice = mvOfferPrice - discount;

  return Math.max(finalPrice, 0);
}


   return(
    
    <>
    
{/*     <div style={{position:"fixed", bottom:"0px",background:"white",height:props?.cartItemsList&&props?.cartItemsList[0]&&props?.productDetailsData?.isSample==true?"":props?.cartItemsList[0]?"141px":"100px",width:"100vw",}}>
 */}        
 <div style={{position:"fixed", bottom:"0px",background:"white",height:props?.cartItemsList&&props?.cartItemsList[0]&&props?.productDetailsData?.isSample==true?"":props?.cartItemsList[0]?"100px":"100px",width:"100vw",}}>
 <hr/>
        <div style={{display:"flex",justifyContent:"space-between",    padding:"20px 15px 10px 15px",
    width: "100%",    alignItems: "flex-end"}}>
        <div>
        <p className="bottomData" style={{fontWeight:"500",fontSize:"12px",padding:"5px",color:" #757575"}}>{props?.productDetailsData?.product_details.packageWeight}{" "}{props?.productDetailsData?.product_details.quantityType}</p>
        <p className="bottomData"style={{fontWeight:"600",fontSize:"14px",padding:"5px",color: "#384F6F"}} >                     ₹{props?.productDetailsData?.isSample==true?calculateFinalPrice(props?.productDetailsData).toFixed(2):props?.productDetailsData?.mvOfferPrice.toFixed(2) }</p>
        <p className="bottomData"style={{fontWeight:"400",fontSize:"12px",padding:"5px",color: "#94A3B8"}} >Inclusive of all taxes</p>
        </div>
        <div>
            {props?.cartItemsList.length<0?


<>           
            <div style={{    display: "flex",alignItems:"center",color: "#129A69",

    justifyContent: "center",height: "45px",
    width: "110px",background:" #00B1770A",border: "1px solid #129A69",borderRadius:"8px"}}>
            Notify Me
            </div>

            </>
            
            
            
            :
            <>
        {/*     {logger.log("khan foundItem",foundItem)
            } */}
            {foundItem&&foundItem?

            <div  style={{    color:"white",background: "#129A69",display: "flex",alignItems:"center",display: "flex",justifyContent:"space-around",

justifyContent: "center",    height: "45px",
    width: "110px",border: "1px solid #129A69",borderRadius:"8px",    justifyContent: "space-around"}}>
      <span onClick={(e)=>{RemoveToCartFromBottom(e,foundItem.slotId,foundItem.count)}} >-</span>{foundItem&&foundItem.count}<span onClick={(e)=>{addToCartFromBottom(e,1,foundItem.slotId,foundItem.count,machine_id)}}>+</span>
        </div>
        
        :  
        <div>
            {props?.productDetailsData?.activeCount>0?
        
        <div  onClick={(e)=>{addToCartFromBottom(e,0,slot_id,0,machine_id)}} style={{    color:"white",background: "#129A69",display: "flex",alignItems:"center",display: "flex",justifyContent:"space-around",

justifyContent: "center",  height: "45px",
    width: "110px",border: "1px solid #129A69",borderRadius:"8px",    justifyContent: "space-around"}}>
     ADD
        </div>:    <div style={{    color:"white",background: "rgb(127 134 132)",display: "flex",alignItems:"center",display: "flex",justifyContent:"space-around",

justifyContent: "center", height: "45px",
    width: "110px",borderRadius:"8px",    justifyContent: "space-around"}}>
     ADD
        </div>}
        </div>
}
        </>
        }
        </div>

        </div>

    </div>
    
    
    </>)
}

export default Bottom